

  import {Component, Vue} from "vue-property-decorator";

  @Component({name:'ElTableColumnCopy'})
  export default class ElTableColumnCopy extends Vue{

  }

